/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
 */
import 'mathjax/es5/startup.js';
import 'mathjax/es5/core.js';
import 'mathjax/es5/input/mml.js';
import 'mathjax/es5/output/svg.js';
import 'mathjax/es5/output/svg/fonts/tex.js';
import 'mathjax/es5/a11y/assistive-mml.js';

let initialized = false;

/**
 * Get an initialized instance of MathJax
 * @returns {Promise<MathJax>} the initialized MathJax
 */
export function getMathJax() {
    if (initialized) {
        return window.MathJax;
    }
    window.MathJax.startup.defaultReady();
    return window.MathJax.startup.promise.then(() => {
        const originalLoader = window.MathJax.loader.load;
        window.MathJax.loader.load = function (moduleName, ...rest) {
            //only to silence console error produced by 'readAloud' plugin 'textHelp' provider
            //remove if actual module will be properly loaded
            if (moduleName === 'a11y/semantic-enrich') {
                window.MathJax._.a11y.sre = { Sre: {} };
                return Promise.resolve();
            }
            return originalLoader(moduleName, ...rest);
        };

        initialized = true;
        return window.MathJax;
    });
}

/**
 * Get the MathJax object
 * @property {MathJax} MathJax
 */
export default window.MathJax;
